import React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import s from '../styles.module.scss'

import FooterLogin from '../footer-login/footer-login'
import { ResetPasswordInterface } from '../login.types'
import { InputText } from '../../../../components/molecules/input-text'

export interface InputsResetPassword {
  password: string
  passwordCheck?: string
}

interface SubscribeForm extends ResetPasswordInterface {
  setShowResetPassword: React.Dispatch<React.SetStateAction<boolean>>
}

const ResetPasswordForm = ({
  onResetPassword,
  isLoading,
  setShowResetPassword,
}: SubscribeForm) => {
  const {
    control,
    handleSubmit,
    formState: { isValid },
    watch,
    setError,
  } = useForm<InputsResetPassword>({
    defaultValues: {
      password: '',
      passwordCheck: '',
    },
    mode: 'onChange',
  })

  const onSubmit: SubmitHandler<InputsResetPassword> = async ({ password }) => {
    try {
      await onResetPassword({ password })
    } catch {
      setError('password', {
        type: 'string',
        message: 'Une erreur est survenue. Veuillez réessayer ultérieurement.',
      })
      setError('passwordCheck', {
        type: 'string',
        message: 'Une erreur est survenue. Veuillez réessayer ultérieurement.',
      })
    }
  }

  return (
    <form className={s.form}>
      <h2 className={s.title}>Réinitialisez votre mot de passe</h2>
      <InputText
        control={control}
        name='password'
        label='Mot de passe'
        rules={{
          validate: (password: string | undefined) =>
            password && password.length >= 6 ? true : 'Minimum 6 caractères',
        }}
        inputProps={{
          type: 'password',
          'aria-label': 'entrez votre mot de passe',
          'aria-required': 'true',
        }}
        placeholder='Entrez votre mot de passe'
      />
      <InputText
        control={control}
        name='passwordCheck'
        label='Confirmez le mot de passe'
        rules={{
          validate: (password: string | undefined) =>
            password === watch('password')
              ? true
              : 'Les mots de passe ne correspondent pas',
        }}
        inputProps={{
          type: 'password',
          'aria-label': 'entrez votre mot de passe',
          'aria-required': 'true',
        }}
        placeholder='Entrez votre mot de passe'
      />

      <FooterLogin
        footerElement={
          <div className={s.link}>
            <span
              className={s.underline}
              onClick={() => setShowResetPassword(false)}
            >
              Retour à l&apos;accueil
            </span>
          </div>
        }
        submit={{
          isLoading,
          onSubmit: handleSubmit(onSubmit),
          label: 'Réinitialiser',
          isValid,
        }}
      />
    </form>
  )
}

export default ResetPasswordForm
